export const frontdeskRoutes = [
  "/frontdesk/checked-out/group",
  "/frontdesk/checked-out/individual",
  "/frontdesk/security-&-auditor-report",
  "/frontdesk/guest-bills/individual",
  "/frontdesk/guest-bills/group",
  "/frontdesk/checked-in/group",
  "/frontdesk/checked-in/individual",
  "/frontdesk/arrivals/individual/print-reg-card/:guestId",
  "/frontdesk/departures/group",
  "/frontdesk/departures/individual",
  "/frontdesk/room-details/room-status",
  "/frontdesk/room-details/room-type-summary",
  "/frontdesk/history",
  "/frontdesk/arrivals/group",
  "/frontdesk/arrivals/individual",
  "/frontdesk/pm-account/checked-out",
  "/frontdesk/pm-account/in-house",
  "/frontdesk/pm-account/debt-ledger",
  "/frontdesk/facilities/facility",
  "/frontdesk/facilities/events",
  "/frontdesk/end-of-day",
];

{
  /* ============================== Reservations =================================== */
}

export const reservationRoutes = [
  "/reservations",
  "/reservations/schedules/calendar",
  "/reservations/receipts",
  "/reservations/new-reservation/individual",
  "/reservations/schedules/future-individual-arrivals",
  "/reservations/schedules/future-group-arrivals",
  "/reservations/schedules/future-occupancies",
  "/reservations/new-reservation/group",
  "/reservations/update-individual-reservations/:id",
  "/reservations/update-group-reservations/:id",
  "/reservations/reservation-table/individual",
  "/reservations/reservation-table/group",
  "/reservations/room-status",
  "/reservations/profiles",
];
{
  /* ============================== Settings =================================== */
}
export const settingsRoutes = [
  "/settings/charges/frontdesk-charges",
  "/settings/credits/frontdesk-credits",
  "/settings/charges/taxes",
  "/settings/charges/f-and-b-discounts",
  "/settings/charges/f-and-b-charges",
  "/settings/credits/f-and-b-credits",

  "/settings/charges/f-and-b-virtual-rooms",
  "/settings/charges/payment-method",

  "/settings/communications",

  "/settings/inventory-management/major-group",
  "/settings/inventory-management/family-group",
  "/settings/inventory-management/f-and-b-time",
  "/settings/inventory-management/menu-items",
  "/settings/inventory-management/f-and-b-tables",

  "/settings/inventory-management/add-pool-bar-menu-item",

  "/settings/room-settings/room-floor",
  "/settings/room-settings/room-type",
  "/settings/room-settings/rate-type",
  "/settings/room-settings/rate-name",
  "/settings/room-settings/room-and-rates",
  "/settings/room-settings/bar-rates",
  "/settings/room-settings/room-status",
  "/settings/pm-account/checked-out",
  "/settings/pm-account/in-house",

  "/settings/user-management/users",
  "/settings/user-management/shifts",
  "/settings/user-management/shift-timing",
  "/settings/user-activities/user-logs",

  "/settings/group-management/groups",
  "/settings/group-management/group-rate",
  "/settings/group-management/membership-type",

  "/settings/table-management/table-listing",
  "/settings/table-management/table-location",
  "/settings/companies",
  "/settings/other-setups/title",
  "/settings/other-setups/hotel-date",
  "/settings/other-setups/permissions",
  "/settings/other-setups/communications",
  "/settings/other-setups/non-occupied-rooms",
  "/settings/other-setups/source",
  "/settings/other-setups/virtual-orders",
  "/settings/licenses",
  "/settings/facilities",
];
{
  /* ============================== Records =================================== */
}
export const recordsRoutes = [
  "/records/financial-transactions",
  "/records/city-ledger",
  "/records/daily-managers'-flash",
  "/records/weekly-managers'-flash",
  "/records/trial-balance",
  "/records/receipts",
  "/records/charges",
  "/records/credits",
  "/records/folios",
  "/records/market-count-segmentation",
  "/records/market-worth-segmentation",
  "/records/room-type-count-segmentation",
  "/records/room-type-worth-segmentation",

  "/records/deposits",
  "/records/f&b-revenues",
  "/records/f&b-sales-ledger",
  "/records/front-office-ledger",

  "/records/guests-in-house",

  "/records/bar-daily-sales",
  "/records/pool-bar-daily-sales",
  "/records/restaurant-daily-sales",
  "/records/daily-logs",
  "/records/cashiers-summary-report",
  "/records/cashiers-breakdown-report",
  "/records/monthly-report",
];

{
  /* ============================== House Keeping =================================== */
}
export const houseKeepingRoutes = [
  "/house-keeping/room-status",
  "/house-keeping/stocks",
  "/house-keeping/room-type-summary",
];
{
  /* ===================== Restaurant ====================================== */
}
export const restaurantRoutes = [
  "/restaurant/guests-in-house/individual",
  "/restaurant/guests-in-house/group",
  "/restaurant/sales/receipts",
  "/restaurant/point-of-sales",
  "/restaurant/orders",
  "/restaurant/folios",
  "/restaurant/tables",
  "/restaurant/backtrack",
  "/restaurant/sales/daily",

  "/restaurant/sales/shift",
  "/restaurant/stocks",
  "/restaurant/current-stocks",
  "/restaurant/sales/items-sold",
  "/restaurant/kitchen-orders",
];
{
  /* ===================== Room Service ====================================== */
}
export const roomserviceRoutes = [
  "/room-service/guests-in-house",
  "/room-service/sales/receipts",
  "/room-service/point-of-sales",
  "/room-service/orders",
  "/room-service/folios",
  "/room-service/tables",
  "/room-service/backtrack",
  "/room-service/sales/daily",
  "/room-service/sales/shift",
  "/room-service/stocks",
  "/room-service/sales/items-sold",
  "/room-service/kitchen-orders",
];
{
  /* ========================== Bar ================================= */
}
export const mainBarRoutes = [
  "/main-bar/point-of-sales",
  "/main-bar/guests-in-house/individual",
  "/main-bar/guests-in-house/group",
  "/main-bar/folios",
  "/main-bar/sales/receipts",
  "/main-bar/orders",
  "/main-bar/tables",
  "/main-bar/sales/daily",
  "/main-bar/sales/shift",
  "/main-bar/stocks",
  "/main-bar/current-stocks",
  "/main-bar/sales/items-sold",
  "/main-bar/kitchen-orders",
];
{
  /* ============================= Pool Bar ================================= */
}
export const poolBarRoutes = [
  "/pool-bar/point-of-sales",
  "/pool-bar/sales/receipts",
  "/pool-bar/guests-in-house/individual",
  "/pool-bar/guests-in-house/group",
  "/pool-bar/folios",
  "/pool-bar/stocks",
  "/pool-bar/current-stocks",
  "/pool-bar/tables",
  "/pool-bar/sales/daily",
  "/pool-bar/sales/shift",
  "/pool-bar/orders",
  "/pool-bar/sales/items-sold",
  "/pool-bar/kitchen-orders",
];
{
  /* ============================== Store ======================================= */
}
export const storeRoutes = [
  "/store/sections",
  "/store/records/outlets",
  "/store/records/items",
  "/store/items",
  "/store/logs",
  "/store/outlets",
];
{
  /* ================================================================================== */
}
{
  /* ============================== Kitchen ======================================= */
}
//  "/kitchen",
//  "/kitchen/queued-orders",
//  "/kitchen/preparing-orders",
//  "/kitchen/daily-discharged-orders",
//  "/kitchen/shift-discharged-orders",
//  "/kitchen/stocks",
{
  /* ================================================================================== */
}
{
  /* =================== Backtrack ==================================================== */
}
export const backtrackRoutes = [
  "/backtrack/accommodation/individual",
  "/backtrack/accommodation/group",

  "/backtrack/guests/individual",
  "/backtrack/guests/group",
  "/backtrack/pm-account",

  "/backtrack/restaurant",
  "/backtrack/bar",
  "/backtrack/pool-bar",
  "/backtrack/no-eod",
  "/backtrack/facilities/facility",
  "/backtrack/facilities/events",
];
{
  /* ========================== Accounts ==================================================== */
}
export const accountsRoutes = [
  "/accounts/",
  "/accounts/pm-account/checked-out",
  "/accounts/pm-account/in-house",
  "/accounts/receivables",
  "/accounts/aging-analysis",
  "/accounts/debt-ledger",
  "/accounts/history",
  "/accounts/checked-in/individual",
  "/accounts/checked-in/group",
];
{
  /* ========================== Statistics ==================================================== */
}
export const statisticsRoutes = [
  "/statistics/managers-flash",
  "/statistics/market-segments",
  "/statistics/rates",
  "/statistics/guests",
  "/statistics/f&b",
];
